import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'

const TextWithOverline = ({ text, overlineText }) => (
  <>
    <Typography
      style={{
        fontSize: '12px',
        color: 'rgb(158, 158, 158)',
        fontWeight: '500',
      }}
    >
      {overlineText}
    </Typography>
    <Typography>{text}</Typography>
  </>
)

TextWithOverline.propTypes = {
  text: PropTypes.string,
  overlineText: PropTypes.string,
}

const formatAddressLine = (city, state, zip) => {
  const result = []
  if (city) result.push(`${city.trim()}, `)
  if (state) result.push(`${state.trim()} `)
  if (zip) result.push(zip.trim())

  return result.join('')
}

export default function FacilityDisplay({ values }) {
  const optionalFacilityFields = [
    values.street,
    formatAddressLine(values.city, values.state, values.zipCode),
    values.phoneNumber,
    values.website,
  ]
  return (
    <Box mb={2}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h6">Facility Information</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontWeight: 600 }}>
            {values.facilityName}
          </Typography>
          {optionalFacilityFields
            .filter(obj => obj)
            .map(field => {
              // the filter removes null/empty fields
              return <Typography>{field}</Typography>
            })}
        </Grid>
        {values.isPrivate ? (
          <Grid item xs={12}>
            <em>This is a private facility.</em>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  )
}

FacilityDisplay.propTypes = {
  values: PropTypes.object,
}
